import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import 'react-multi-carousel/lib/styles.css';
import useWindowDimensions from '../../../../common/hooks/useWindowDimensions';
import styles from '../login.module.scss';
import { UserService } from '../../../../common/services/user/user.service';

const userService = new UserService();
const Faqs = () => {
  const [itemID, setItemId] = useState('1');
  const { width } = useWindowDimensions();
  const [faqsData, setFaqsData] = useState([]);
  const [called, setCalled] = useState(false);

  const handleClick = (event: { currentTarget: { id: any } }) => {
    setItemId(`${event.currentTarget.id}`);
  };
  const [expanded, setExpanded] = useState<string | false>(false);

  useEffect(() => {
    const getAllFAQs = async () => {
      setCalled(true);
      try {
        // const result = await axios.get('/api/faq');
        const result = await userService.getFaqs();
        setFaqsData(result);
      } catch (err) {
        console.error('Failed to fetch FAQs:', err);
      }
    };

    if (!called) {
      getAllFAQs();
    }
  }, []);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return width > 767 ? (
    <section className={styles.faqsWrapper} id="faqs">
      <div className={styles.faqsInternal}>
        <div className={styles.faqsInternalWrap}>
          <h1 className={styles.faqTitle}>FAQs</h1>
          <div className={styles.containerFAQs}>
            <div className={styles.leftSection}>
              {faqsData?.map((faq, index) => (
                <div
                  className={styles.list}
                  id={`${index + 1}`}
                  onClick={handleClick}
                  style={{
                    backgroundColor:
                      itemID === `${index + 1}` ? '#fff' : '#f5f5f5',
                  }}
                >
                  <div
                    className={styles.line}
                    style={{
                      display: itemID === `${index + 1}` ? 'block' : 'none',
                      fontWeight: '800',
                    }}
                  >
                    {' '}
                  </div>
                  <div className={styles.item}>
                    <div
                      style={{
                        fontWeight: itemID === `${index + 1}` ? 'bold' : '',
                      }}
                    >
                      {faq?.question}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.rightSection}>
              <div>
                {faqsData[Number(itemID) - 1]?.answer?.map((sub: any) => (
                  <ul>
                    <li>
                      <div className={styles.faqAnswer}>
                        {sub?.question ?? sub}
                      </div>
                      {sub?.answer?.length ? (
                        sub?.answer?.map((sub1: any) => (
                          <ul>
                            <li>{sub1.question}</li>
                            {sub1.answer?.length ? (
                              sub1.answer?.map((sub2: any) => (
                                <ul>
                                  <li>{sub2}</li>
                                </ul>
                              ))
                            ) : (
                              <></>
                            )}
                          </ul>
                        ))
                      ) : (
                        <></>
                      )}
                    </li>
                  </ul>
                ))}
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <div className={styles.faqsWrapperMobile} id="faqs">
      <h1
        style={{
          textAlign: 'center',
        }}
      >
        FAQs
      </h1>
      <br />
      {faqsData.map((faq, index) => (
        <Accordion
          expanded={expanded === `panel${index + 1}`}
          onChange={handleChange(`panel${index + 1}`)}
        >
          <AccordionSummary
            expandIcon={
              <span className="material-icons-outlined">expand_more</span>
            }
            aria-controls={`panel${index + 1}bh-content`}
            id={`panel${index + 1}bh-header`}
          >
            <h4>{faq.question}</h4>
          </AccordionSummary>
          <AccordionDetails className={styles.accordionDetails}>
            <Typography>
              <div>
                {/* display only those which have answer as an array type. */}
                {Array.isArray(faq.answer) &&
                  faq.answer.map((sub: any) => (
                    <>
                      <div>{sub?.title ?? sub}</div>
                      {sub?.answer?.length ? (
                        sub?.answer?.map((sub1: any) => (
                          <ul>
                            <li>{sub1.title}</li>
                            {sub1.answer?.length ? (
                              sub1.answer?.map((sub2: any) => (
                                <ul>
                                  <li>{sub2}</li>
                                </ul>
                              ))
                            ) : (
                              <></>
                            )}
                          </ul>
                        ))
                      ) : (
                        <></>
                      )}
                      <br />
                    </>
                  ))}
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default Faqs;
